export default {
  setLotteryId(state, lotteryId) {
    state.lotteryId = lotteryId;
    return state;
  },
  setToken(state, token) {
    state.token = token;
    return state;
  },
  setMobile(state, mobile) {
    state.mobile = mobile;
    return state;
  },
  setBackgroud(state, backgroud) {
    state.backgroud = backgroud;
    return state;
  },
  setRule(state, rule) {
    state.rule = rule;
    return state;
  },
  setTitle(state, title) {
    state.title = title;
    return state;
  },
  setAdnum(state, adNum) {
    state.adNum = adNum;
    return state;
  },
};
